'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const ItemTemplate = require('feedback/ui/template/admin/announcement/item.hbs');
const ListTemplate = require('feedback/ui/template/admin/announcement/list.hbs');

const ItemView = Mn.View.extend({
    tagName: 'tr',
    className: 'announcement-item',
    template: ItemTemplate,

    templateContext: function() {
        return {
            url: `/feedback/admin/announcements/${this.model.getID()}`,
            state: i18n.t(`feedback:announcement.state.${this.model.getState()}`),
            isDisplayed: this.model.isDisplayed(),
            categoryName: i18n.t(`feedback:announcement.category.${this.model.getCategoryName()}`)
        }
    }
});

const ListView = Mn.CompositeView.extend({
    tagName: 'div',
    className: 'announcement-list row',
    template: ListTemplate,
    childView: ItemView,
    childViewContainer: '.announcement-container',
});

module.exports = ListView;



// WEBPACK FOOTER //
// ./feedback/ui/view/admin/announcement/list.js